import { useCallback } from 'react';

import type { ActionsReturnType, PostSharingHookProps } from './types';

// TODO: Implement
export function useFacebookPostSharing(_input: PostSharingHookProps): ActionsReturnType {
	const primaryAction = useCallback(() => {}, []);

	return {
		primaryAction,
		secondaryAction: undefined,
	};
}
